import api from "./api";

export async function fetchDashboard(): Promise<any> {
  let url = "";
  url = `/Dashboard`;

  const response = await api.get(url);
  return response;
}